/* ***************************************************************** */
/*                                                                   */
/* Licensed Materials - Property of Merative                         */
/*                                                                   */
/* (C) Copyright Merative Corp. 2025                                 */
/*                                                                   */
/* ***************************************************************** */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {fetchAndHandleResponse} from "../../../../utils";

const processResponse = (responseBody, dispatch, params) => {
  const {docIds, result_type} = params;
  if (responseBody && responseBody[0].docs) {
    const docIdArray = [];
    responseBody.forEach(item => {
      if (item.docs && Array.isArray(item.docs)) {
        item.docs.forEach(doc => {
          if (doc.docId) {
            docIdArray.push(doc);
          }
        });
      }
    });

    dispatch(saveProductNotes({notes: docIdArray, docIds, result_type}))
  }
};

export const fetchAndSaveProductNotes = createAsyncThunk('neonatal_drugs/fetchDrugs', async (params, {
  dispatch,
  rejectWithValue
}) => {
  return await fetchAndHandleResponse(params, dispatch, rejectWithValue, processResponse);
});

const initialState = {
  product_notes_full_data: [],
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
  neofax: {
    product_notes_ids: [],
    product_notes_info: [],
  },
  pediatrics: {
    product_notes_ids: [],
    product_notes_info: [],
  }
}

const enteralFormulaProductNotesSlice = createSlice({
  name: 'enteral_formula_product_notes_page',
  initialState: initialState,
  reducers: {
    saveProductNotes: (state, action) => {
      const {notes, docIds, result_type} = action.payload;
      state[result_type].product_notes_ids = docIds;
      state[result_type].product_notes_info = notes;
    },
    removeProductNote: (state, action) => {
      const result_type = action.payload.result_type;
      const docId = action.payload.docId;
      state[result_type].product_notes_info = state[result_type].product_notes_info.filter(note => note.docId !== docId);
      state[result_type].product_notes_ids = state[result_type].product_notes_ids.filter(id => id !== docId);
    },
    clearProductNotesState: () => {
      return initialState;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAndSaveProductNotes.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAndSaveProductNotes.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.product_notes_full_data = action.payload;
        state.error = null;
      })
      .addCase(fetchAndSaveProductNotes.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  }
});

export const {saveProductNotes, removeProductNote, clearProductNotesState} = enteralFormulaProductNotesSlice.actions;

export const selectFormulaDocIds = (state) => (result_type) =>
  state.enteral_formula_product_notes_page[result_type].product_notes_ids;
export const selectFormulaNotes = (state) => (result_type) =>
  state.enteral_formula_product_notes_page[result_type].product_notes_info;


export default enteralFormulaProductNotesSlice.reducer;